import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Upload, Button, Input, InputNumber, Select, Icon, DatePicker, message } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import ExportFixedLine from './ExportFixedLine';
import ExportModal from './ExportModal';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import { xToken } from '../../../../common/AjaxRequest';
import ExportUtil from '../../../../common/ExportUtil';
import { Default, Symbols, RequestStatus } from '../constants';
import UpdateWord from './UpdateWord';
import DownloadWord from './DownloadWord';
import SearchMulRetrieve from '../../../common/SearchMulRetrieve.js';
import moment from 'moment';

const genOptions = data =>  Object.keys(data).map(i => <Option key={i} value={i}>{ data[i] }</Option>);

const dateFormat = 'YYYY-MM-DD';
const { RangePicker, MonthPicker } = DatePicker;
const InputGroup = Input.Group;
const { Option } = Select;
const DefaultOption = genOptions(Default);
const SymbolsOption = genOptions(Symbols);
const RequestStatusOption = genOptions(RequestStatus);

class Filter extends Component {
    static contextTypes = {
        curRole: PropTypes.string,
        businessList: PropTypes.array,
        signingUnit: PropTypes.array,
        belongingToUnit: PropTypes.array,
        contractTypeList: PropTypes.array,
        stageList: PropTypes.array,
        areaOptions: PropTypes.array,
        adjustStatusList: PropTypes.array,
    }

    constructor(props) {
        super(props);
        this.state = {
            expand: false,
            uploading: false,
            fileList: [],
            diseaseOptions:[],
        };
    }

    search = () => {
        this.props.search();
    }

    loadDiseaseList = investigationAreaId => {
        if (!investigationAreaId) return;
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllDisease,
            data: { investigationAreaId },
            dataType: 'json',
            doneResult: res => {
                const diseaseOptions = (res.data || []).map(item => {
                    const { diseaseId, diseaseName } = item;
                    return {
                        value: diseaseId,
                        label: diseaseName,
                    };
                });
                this.setState({ diseaseOptions });
            },
        };
        $.sendRequest(options);
    }

    handleSearchChange = (value, option, key) => {
        const { searchParams, onChange } = this.props;
        let list = searchParams[key] ? searchParams[key].split(',') : [];
        if (option) {
            list.push(option.value);
        } else {
            list = list.filter(i => i != value);
        }
        if( !value.length ) {
            list = [];
        }
        searchParams[key] = list.join(',');
        onChange(searchParams);
    }

    handleChange = (value, key, option) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'pmUser':
            case 'bdUser':
            case 'baUser':
            case 'csaUser': {
                const {value: id, text: name} = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                break;
            }
            case 'lineOfBusinessIds':
            case 'stageIds':
                searchParams[key] = value ? value.join(',') : undefined;
                if (key === 'lineOfBusinessIds') {
                    searchParams.secondLineName = undefined;
                }
                onChange(searchParams);
                break;
            case 'createTime': {
                const [start, end] = value;
                searchParams[`${key}Start`] = start;
                searchParams[`${key}End`] = end;
                break;
            }
            case 'investigationAreaId' : {
                searchParams[key] = value;
                value ? this.loadDiseaseList(value) : searchParams['diseaseId'] = value;
            }
            default:
                searchParams[key] = value;
        }
        onChange(searchParams);
    }

    export = () => {
        this.exportModal.show();
    }

    download = () => {
        const url = API_URL.investigation.getInvJdeContractHistory;
        ExportUtil.export(null, null, url);
    }

    beforeUpload = () => {
        this.setState({ uploading: true });
    }

    handleUploadChange = ({ file, fileList }) => {
        const { fileList: fList } = this.state;
        const { status, uid, response } = file;
        if (status === 'done' && (fList || []).find(i => i.uid == uid)) {
            this.setState({ uploading: false });
            const { success, error, failDataNum } = response || {};
            if (success) {
                Modal.confirm({
                    iconType: 'exclamation-circle',
                    title: '本次导入的历史合同',
                    content: (success || '').split(';').map(i => <span>{i}<br /></span>),
                    onOk: () => {
                        if (failDataNum) {
                            const url = API_URL.investigation.exportFailRecordList;
                            ExportUtil.export(null, null, url);
                        }
                    },
                    okText: failDataNum ? '下载错误报告' : '确定',
                    cancelText: '关闭',
                });
                this.search();
            } else if (error) {
                message.error(error);
            }
        }

        this.setState({ fileList });
    }

    showFixedLine = () => {
        this.exportFixedLineRef.show();
    }

    updateWord = () => {
        this.updateWordRef.show();
    }
    
    downloadWord = () => {
        this.downloadWordRef.show();
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render () {
        const { curRole, businessList, signingUnit, belongingToUnit, contractTypeList, stageList, areaOptions, adjustStatusList } = this.context;
        const { searchParams, history, toggle, update, canUpload } = this.props;
        const { expand, fileList, uploading, diseaseOptions } = this.state;
        const { lineOfBusinessIds, customerCompanyIds } = searchParams;
        const isPM = curRole === 'PM';
        const isBD = curRole === 'BD';
        const isBDM = curRole === 'BDM';
        const isBA = curRole === 'BA';
        const isPML = curRole === 'PML';
        const isFIN = curRole === 'FIN';
        const isCTA = curRole === 'CTA';
        const isVP = curRole === 'VP';
        const isBO = curRole === 'BO';
        const isBAL = curRole === 'BAL';
        const isBDO = curRole === 'BDO';
        const isCSA = curRole === 'CSA';
        const isCSAL = curRole === 'CSAL';
        const secondLineSet = new Set();
        businessList.forEach(i => {
            const arr = (lineOfBusinessIds || '').split(',');
            if (arr.some(j => j == i.typeConfigureId)) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const stageOption = stageList.map(d => <Option key={String(d.typeConfigureId)} title={d.typeValue}>{d.typeValue}</Option>);
        const areaOption = areaOptions.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        const diseaseOption = diseaseOptions.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        const businessOption = businessList.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const signingUnitOption = signingUnit.map(i => <Option key={i.unitOfSigningId}>{i.unitOfSigningName}</Option>);
        const belongingToUnitOption = belongingToUnit.map(i => <Option key={i.unitOfBelongingId}>{i.unitOfBelongingName}</Option>);
        const contractTypeOption = contractTypeList.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
        const customerCompanyList = customerCompanyIds ? customerCompanyIds.split(',') : [];
        const adjustStatusOption = (adjustStatusList || []).map(i => <Option key={i.value}>{i.label}</Option>);
        return (
            <div style={{ marginBottom: 20 }}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                    <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">JDE主项目号</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 110 }}
                            value={searchParams.investigationJdeMainCode}
                            onChange={e => this.handleChange(e.target.value, 'investigationJdeMainCode')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目简称</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 140 }}
                            value={searchParams.investigationName}
                            onChange={e => this.handleChange(e.target.value, 'investigationName')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目编号</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 120 }}
                            value={searchParams.investigationCode}
                            onChange={e => this.handleChange(e.target.value, 'investigationCode')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目阶段</label>
                        <Select
                            className="multiple-stage"
                            mode="multiple"
                            filterOption={false}
                            placeholder="请选择"
                            style={{ width: 120 }}
                            value={searchParams.stageIds ? searchParams.stageIds.split(',') : []}
                            onChange={value => this.handleChange(value, 'stageIds')}
                        >
                            {stageOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目领域</label>
                        <Select
                            allowClear={true}
                            style={{ width: 120 }}
                            placeholder="请选择"
                            value={searchParams.investigationAreaId}
                            onChange={value => this.handleChange(value, 'investigationAreaId')}
                        >
                            {areaOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">疾病</label>
                        <Select
                            allowClear={true}
                            style={{ width: 120 }}
                            placeholder="请选择"
                            disabled={!searchParams.investigationAreaId}
                            value={searchParams.diseaseId}
                            onChange={value => this.handleChange(value, 'diseaseId')}
                        >
                            {diseaseOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">PM</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 130 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.pmUserName}
                            params={{ limit: 20, workStatus: 'ALL' }}
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'pmUser')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">BD</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.bdUserName}
                            params={{ limit: 20, workStatus: 'ALL' }}
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'bdUser')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">合同BA</label>
                        <SearchRetrieve
                            keyword='keyWord'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.baUserName}
                            params={{ limit: 20, roleCodes: 'BA,BAL', workStatus: 'ALL' }}
                            url={API_URL.teaching.queryEmpListByRoleCode}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'baUser')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">客户CSA</label>
                        <SearchRetrieve
                            keyword='keyWord'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.csaUserName}
                            params={{ limit: 20, roleCodes: 'CSA,CSAL' }}
                            url={API_URL.execute.queryEmpListByRoleCode}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'csaUser')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目关闭申请情况</label>
                        <span>
                            <Select
                                allowClear={true}
                                style={{ width: 120 }}
                                placeholder="请选择"
                                value={searchParams.invRemittanceCompletedInfo}
                                onChange={value => this.handleChange(value, 'invRemittanceCompletedInfo')}
                            >
                                <Option value={'UN_APPLY'}>待申请</Option>
                                <Option value={'TO_BE_CHARGE_USER_CONFIRM'}>待负责人确认</Option>
                                <Option value={'CHARGE_USER_REJECT'}>负责人拒绝确认</Option>
                                <Option value={'CHARGE_USER_CONFIRMED'}>负责人已确认</Option>
                                <Option value={'TO_BE_FIN_CONFIRM'}>待FIN确认</Option>
                                <Option value={'FIN_REJECT'}>FIN拒绝确认</Option>
                                <Option value={'FIN_CONFIRMED'}>FIN已确认</Option>
                            </Select>
                        </span>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目财务数据调整情况</label>
                        <span>
                            <Select
                                allowClear={true}
                                style={{ width: 160 }}
                                placeholder="请选择"
                                value={searchParams.adjustStatus}
                                onChange={value => this.handleChange(value, 'adjustStatus')}
                            >
                                {adjustStatusOption}
                            </Select>
                        </span>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目关闭时间</label>
                        <MonthPicker
                            style={{ width: 120 }}
                            value={searchParams.invCloseDate ? moment(searchParams.invCloseDate) : null}
                            onChange={(date, dateString) => this.handleChange(dateString, 'invCloseDate')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">JDE项目号</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 110 }}
                            value={searchParams.investigationJdeCode}
                            onChange={e => this.handleChange(e.target.value, 'investigationJdeCode')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">名称(ProjectID)</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 110 }}
                            value={searchParams.projectIdName}
                            onChange={e => this.handleChange(e.target.value, 'projectIdName')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">计收入确认方式</label>
                        <Select
                            allowClear = {true}
                            style={{width: 100}}
                            placeholder="请选择"
                            value={format('toString', searchParams.contractTypeId)}
                            onChange = {value => this.handleChange(value, 'contractTypeId')}
                        >
                            {contractTypeOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">合同是否签署完成</label>
                        <Select
                            allowClear = {true}
                            style={{width: 80}}
                            placeholder="请选择"
                            value={format('toString', searchParams.investigationJdeContractIsSigned)}
                            onChange = {value => this.handleChange(value, 'investigationJdeContractIsSigned')}
                        >
                            {DefaultOption}
                        </Select> 
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">合同额含税/人民币(元)</label>
                        <InputGroup compact>
                            <Select
                                value={searchParams.jdeContractAmountSymbol}
                                onChange={value => this.handleChange(value, 'jdeContractAmountSymbol')}
                            >
                                {SymbolsOption}
                            </Select>
                            <InputNumber
                                style={{ width: 110 }}
                                precision={2}
                                placeholder="请输入"
                                value={searchParams.jdeContractAmount}
                                onChange={value => this.handleChange(value, 'jdeContractAmount')}
                            />
                        </InputGroup>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">合同开始时间</label>
                        <InputGroup compact>
                            <Select
                                value={searchParams.startTimeSymbol}
                                onChange={value => this.handleChange(value, 'startTimeSymbol')}
                            >
                                {SymbolsOption}
                            </Select>
                            <DatePicker
                                style={{width: 110}}
                                value={format('toMoment', searchParams.startTime)}
                                onChange={(date, dateString) => this.handleChange(dateString, 'startTime')}
                            />
                        </InputGroup>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">合同结束时间</label>
                        <InputGroup compact>
                            <Select
                                value={searchParams.endTimeSymbol}
                                onChange={value => this.handleChange(value, 'endTimeSymbol')}
                            >
                                {SymbolsOption}
                            </Select>
                            <DatePicker
                                style={{width: 110}}
                                value={format('toMoment', searchParams.endTime)}
                                onChange={(date, dateString) => this.handleChange(dateString, 'endTime')}
                            />
                        </InputGroup>
                    </div>
                    {/* <div className="search-item">
                        <label htmlFor="" className="ui-label">合同请款完成情况</label>
                        <span>
                            <Select
                                allowClear={true}
                                style={{ width: 120 }}
                                placeholder="请选择"
                                value={searchParams.remittanceCompletedInfo}
                                onChange={value => this.handleChange(value, 'remittanceCompletedInfo')}
                            >
                                {RequestStatusOption}
                            </Select>
                        </span>
                    </div> */}
                    <div className="search-item">
                        <label className="ui-label">业务线</label>
                        <Select
                            mode="multiple"
                            allowClear={true}
                            placeholder="请选择"
                            filterOption={false}
                            style={{width: 120}}
                            className="multiple-stage"
                            value={format('toArray', searchParams.lineOfBusinessIds)}
                            onChange={value => this.handleChange(value, 'lineOfBusinessIds')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusinessIds}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">合同签署单位</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 140}}
                            value={format('toString', searchParams.signingUnit)}
                            onChange={value => this.handleChange(value, 'signingUnit')}
                        >
                            {signingUnitOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">收入归属单位</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={format('toString', searchParams.belongingToUnit)}
                            onChange={value => this.handleChange(value, 'belongingToUnit')}
                        >
                            {belongingToUnitOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">合同新增时间</div>
                        <RangePicker
                            style={{width: 200}}
                            format={dateFormat}
                            value={format('toMoment', [searchParams.createTimeStart, searchParams.createTimeEnd])}
                            onChange={(dates, dateStrings) => this.handleChange(dateStrings,'createTime')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">客户全名</label>
                        <SearchMulRetrieve
                            keyword='customerCompanyName'
                            style={{ width: 162 }}
                            placeholder="输入名称检索"
                            value={customerCompanyList}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={(value, option) => this.handleSearchChange(value, option, 'customerCompanyIds')}
                        />
                    </div>
                    {
                        !history && 
                        <div className="search-item">
                            <label className="ui-label">是否据实结算</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 80}}
                                value={searchParams.isRealitySettle}
                                onChange={value => this.handleChange(value, 'isRealitySettle')}
                            >
                                <Option value={-1}>为空</Option>
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </div>
                    }
                    {
                        !history &&
                        <div className="search-item">
                            <label className="ui-label">MSA特殊优惠是否从合同额中扣减</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 80}}
                                value={searchParams.isMsaSpecialContractReduce}
                                onChange={value => this.handleChange(value, 'isMsaSpecialContractReduce')}
                            >
                                <Option value={-1}>为空</Option>
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </div>
                    }
                    {
                        !history &&
                        <div className="search-item">
                            <label className="ui-label">客户是否MSA特殊优惠客户</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 80}}
                                value={searchParams.isMsaSpecialDiscountCustom}
                                onChange={value => this.handleChange(value, 'isMsaSpecialDiscountCustom')}
                            >
                                <Option value={-1}>为空</Option>
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </div>
                    }{
                        !history && 
                        <div className="search-item">
                            <label className="ui-label">是否在优惠有效期内</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 80}}
                                value={searchParams.isDiscountTermValidity}
                                onChange={value => this.handleChange(value, 'isDiscountTermValidity')}
                            >
                                <Option value={-1}>为空</Option>
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </div>
                    }
                    
                </div>
                <div className="search-bar flex-end">
                    {
                        !history ?
                            <div className="search-item">
                                {canUpload && <Button type="primary" onClick={this.updateWord}>上传文档</Button>}
                                { <Button className="btn-yellow" onClick={this.downloadWord}>下载文档</Button>}
                                <Button type="primary" onClick={this.search}>搜索</Button>
                                <Button type="primary" onClick={this.export}>导出</Button>
                                {(isCTA || isVP || isBO || isBAL || isBA || isBDO || isFIN || isCSAL) && <Button className="btn-yellow" onClick={this.showFixedLine}>导出固化数据</Button>}
                                {isFIN && <Button className="btn-green" onClick={toggle}>历史合同</Button>}
                            </div>
                        :
                            <div className="search-item">
                                <Button type="primary" onClick={this.search}>搜索</Button>
                                <Button key="download" type="primary" onClick={this.download}>下载模板</Button>,
                                <Upload
                                    key="import"
                                    data={{
                                        curUserId: sessionStorage.userId,
                                        curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                    }}
                                    showUploadList={false}
                                    action={API_URL.investigation.importInvJdeContractHistory}
                                    beforeUpload={this.beforeUpload}
                                    onChange={this.handleUploadChange}
                                    fileList={fileList}
                                    headers={xToken}
                                >
                                    <Button type="primary" disabled={uploading}>导入合同</Button>
                                </Upload>
                                <Button type="primary" onClick={() => update({}, 'add')}>添加</Button>
                                {isFIN && <Button className="btn-green" onClick={toggle}>返回</Button>}
                            </div>
                    }
                </div>
                <ExportFixedLine ref={el => this.exportFixedLineRef = el} type="contractRecord" />
                <ExportModal ref={el => this.exportModal = el} searchParams={searchParams} />
                <UpdateWord ref={el => this.updateWordRef = el} />
                <DownloadWord ref={el => this.downloadWordRef = el}/>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/Filter.js